import { FC, useEffect, useState } from 'react'
import { Divider } from 'antd'
import { CenteredSpin, Pagination } from '../../../ui'
import style from './style.m.less'
import request from '../../../../services/request'
import { FilterActivated, GeneratorCard } from '../../components'
import { IGenerator } from '../../components/GeneratorCard/GeneratorCard'
import { ELoading } from '../../../../store/dictionaries/interfaces'
import { useAppSelector } from '../../../../store/hooks'
import moment from 'moment'
import { EGoStatusType } from '../../../../constants/approval'

interface IGenaratorData {
    gos_active: IGenerator[]
    total: number
}

const PAGE_SIZE = 10

const NonActiveGenerators: FC = () => {
    const [page, setPage] = useState<number>(() => {
        if (localStorage.getItem('my_generators_page')) {
            return Number(localStorage.getItem('my_generators_page'))
        } else {
            localStorage.setItem('my_generators_page', '1')
            return 1
        }
    })
    const [pageSize, setPageSize] = useState<number>(() => {
        if (localStorage.getItem('my_generators_page_size')) {
            return Number(localStorage.getItem('my_generators_page_size'))
        } else {
            localStorage.setItem('my_generators_page_size', String(PAGE_SIZE))
            return PAGE_SIZE
        }
    })

    const [generators, setGenerators] = useState<IGenaratorData>()
    const [loading, setLoading] = useState(true)

    const [energyType, setEnergyType] = useState<number>(() => {
        if (localStorage.getItem('my_generators_energy_type')) {
            return Number(localStorage.getItem('my_generators_energy_type'))
        } else {
            localStorage.setItem('my_generators_energy_type', String(0))
            return 0
        }
    })
    const handleChangeEnergyType = (type: number) => {
        setEnergyType(type)
        localStorage.setItem('my_generators_energy_type', String(type))
    }

    const [goType, setGoType] = useState<number>(() => {
        if (localStorage.getItem('my_generators_go_type')) {
            return Number(localStorage.getItem('my_generators_go_type'))
        } else {
            localStorage.setItem('my_generators_go_type', String(0))
            return 0
        }
    })
    const handleChangeGoType = (type) => {
        setGoType(type)
        localStorage.setItem('my_generators_go_type', String(type))
    }

    const [dateFilter, setDateFilter] = useState<[moment.Moment, moment.Moment] | null>(() => {
        if (localStorage.getItem('my_generators_date_filter')) {
            let dateArr = JSON.parse(localStorage.getItem('my_generators_date_filter'))
            if (Array.isArray(dateArr) && dateArr.length == 2) {
                return [moment(dateArr[0]), moment(dateArr[1])]
            } else {
                localStorage.setItem('my_generators_date_filter', JSON.stringify(null))
                return null
            }
        } else {
            localStorage.setItem('my_generators_date_filter', JSON.stringify(null))
            return null
        }
    })
    const handleChangeDateFilter = (value: [moment.Moment, moment.Moment] | null) => {
        setDateFilter(value)
        localStorage.setItem('my_generators_date_filter', JSON.stringify(value))
    }

    const [region, setRegion] = useState<number>(() => {
        if (localStorage.getItem('my_generators_region')) {
            return Number(localStorage.getItem('my_generators_region'))
        } else {
            localStorage.setItem('my_generators_region', String(0))
            return 0
        }
    })
    const handleChangeRegion = (region: number) => {
        setRegion(region)
        localStorage.setItem('my_generators_region', String(region))
    }

    const [hasBlocks, setHasBlocks] = useState<EGoStatusType>(() => {
        if (localStorage.getItem('my_generators_has_blocks')) {
            return Number(localStorage.getItem('my_generators_has_blocks'))
        } else {
            localStorage.setItem('my_generators_has_blocks', String(EGoStatusType.All))
            return EGoStatusType.All
        }
    })
    const handleChangeHasBlocks = (type: EGoStatusType) => {
        setRegion(type)
        localStorage.setItem('my_generators_has_blocks', String(type))
    }

    useEffect(() => {
        const loadGenerators = async () => {
            try {
                setLoading(true)
                const res = await request.post('/api/generators/v1/gos-active', {
                    limit: pageSize,
                    offset: (page - 1) * pageSize,
                    filters: {
                        is_active: false,
                        renewable_energy_type_id: energyType,
                        go_type_id: goType,
                        qualification_date_from: dateFilter
                            ? moment(dateFilter[0]).startOf('day')
                            : undefined,
                        qualification_date_to: dateFilter
                            ? moment(dateFilter[1]).endOf('day')
                            : undefined,
                        region_id: region,
                        has_blocks:
                            hasBlocks === EGoStatusType.Blocked
                                ? true
                                : hasBlocks === EGoStatusType.NotBlocked
                                ? false
                                : null,
                    },
                })
                setGenerators(res.data)
            } finally {
                setLoading(false)
            }
        }
        loadGenerators()
    }, [energyType, goType, dateFilter, region, hasBlocks, page, pageSize])

    const dictionariesLoading = useAppSelector((state) => state.dictionaries.loading)

    const realLoading = dictionariesLoading !== ELoading.Loaded || loading || !generators

    return (
        <>
            <div className={style.contentWrapper}>
                <FilterActivated
                    energyType={energyType}
                    onChangeEnergyType={handleChangeEnergyType}
                    goType={goType}
                    onChangeGoType={handleChangeGoType}
                    region={region}
                    onChangeRegionType={handleChangeRegion}
                    dateFilter={dateFilter}
                    onChangeDate={handleChangeDateFilter}
                    hasBlocks={hasBlocks}
                    onChangeStatusTypes={handleChangeHasBlocks}
                />
                <Divider />
                <div className={style.cardsBlock}>
                    {realLoading && <CenteredSpin />}
                    {generators?.gos_active?.map((item, index) => {
                        const { generator_id } = item
                        return (
                            <div key={generator_id}>
                                <GeneratorCard generatorData={item} />
                                {index !== generators?.gos_active?.length - 1 && <Divider />}
                            </div>
                        )
                    })}
                </div>
            </div>
            <Pagination
                customStyle={{ width: '100%' }}
                current={page}
                paginationChange={(receivedPage: number, size?: number) => {
                    setPage(receivedPage)
                    setPageSize(size ?? PAGE_SIZE)
                    localStorage.setItem('my_generators_page', String(receivedPage))
                    localStorage.setItem('my_generators_page_size', String(size ?? PAGE_SIZE))
                }}
                total={generators?.total ?? 0}
                showSizeChanger
                pageSize={pageSize}
            />
        </>
    )
}

export default NonActiveGenerators
